import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PlusIcon, EditIcon } from 'lucide-react';
import { DataTable, Column } from '../components/DataTable';
import { StatusBadge } from '../components/StatusBadge';
import { mockRequisitions } from '../data/mockData';
import { Requisition } from '../types';
export function RequisitionList() {
  const navigate = useNavigate();
  const columns: Column<Requisition>[] = [{
    key: 'reqNo',
    label: 'REQ No',
    render: r => <span className="font-medium text-indigo-600" data-id="element-2048">{r.reqNo}</span>
  }, {
    key: 'department',
    label: 'Department'
  }, {
    key: 'reqFor',
    label: 'Req. For'
  }, {
    key: 'requestedBy',
    label: 'Requested By'
  }, {
    key: 'requiredDate',
    label: 'Required Date'
  }, {
    key: 'totalItems',
    label: 'Total Items'
  }, {
    key: 'status',
    label: 'Status',
    render: r => <StatusBadge status={r.status} data-id="element-2049" />
  }];
  return <div className="space-y-6 h-full flex flex-col" data-id="element-2050">
      <div className="flex items-center justify-between" data-id="element-2051">
        <div data-id="element-2052">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-2053">Requisitions</h1>
          <p className="text-sm text-gray-500 mt-1" data-id="element-2054">
            Manage internal office and employee requests.
          </p>
        </div>
        <button onClick={() => navigate('/requisitions/create')} className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700" data-id="element-2055">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-2056" />
          New Requisition
        </button>
      </div>

      <div className="flex-1" data-id="element-2057">
        <DataTable columns={columns} data={mockRequisitions} keyExtractor={item => item.id} searchPlaceholder="Search requisitions..." onRowClick={item => navigate(`/requisitions/${item.id}/edit`)} actions={item => <div className="flex space-x-3 justify-end" data-id="element-2059">
              <button onClick={() => navigate(`/requisitions/${item.id}/edit`)} className="text-indigo-600 hover:text-indigo-900" data-id="element-2060">
                <EditIcon className="h-4 w-4" data-id="element-2061" />
              </button>
            </div>} data-id="element-2058" />
      </div>
    </div>;
}